import React from 'react'
import '../../style/skeliton.css'
const DemoRequestSkeliton = (props) => {
    const {totalRow} = props;
    return (
        <>
            {[...Array(totalRow)].map((_, index) => (
                <div className="skeleton-row mb-5" key={index}>
                    <div className="cell small">
                        <div className="skeleton-avatar"></div>
                    </div>
                    <div className="cell">
                        <div className="skeleton-box skeleton-small"></div>
                        <div style={{height:'6px'}}></div>
                        <div className="skeleton-box skeleton-medium"></div>
                    </div>
                    <div className="cell">
                        <div className="skeleton-box skeleton-medium"></div>
                    </div>
                    <div className="cell">
                        <div className="skeleton-box skeleton-medium"></div>
                    </div>
                    <div className="cell">
                        <div className="skeleton-box skeleton-medium"></div>
                    </div>
                    <div className="cell">
                        <div className="skeleton-box skeleton-full"></div>
                    </div>
                    <div className="cell">
                        <div className="skeleton-box skeleton-full"></div>
                    </div>
                    <div className="cell">
                        <div className="skeleton-box skeleton-medium"></div>
                    </div>
                    <div className="cell small">
                        <div className="skeleton-box" style={{width:'24px', height: '24px', borderRadius: '4px'}}></div>
                    </div>
                </div>
            ))}
        </>
    )
}

export default DemoRequestSkeliton